import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function OrderPaid() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const sid = params.get("session_id");
  const cancelled = params.get("cancelled");

  useEffect(() => {
    let tries = 0;
    const check = async () => {
      try {
        const { data: d } = await api.get(`/orders/pay/${token}/status`, { params: sid ? { session_id: sid } : {} });
        setData(d);
        if (d.status !== "paid" && sid && tries++ < 5) setTimeout(check, 2000);
      } catch { setError(true); }
    };
    check();
  }, [token, sid]);

  const backend = process.env.REACT_APP_BACKEND_URL;
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-6">
      <Card className="max-w-md w-full p-8 text-center" data-testid="order-paid-page">
        {error ? (
          <><XCircle className="h-10 w-10 text-red-500 mx-auto" /><h1 className="font-heading text-xl font-semibold mt-4">Invoice not found</h1></>
        ) : !data ? (
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
        ) : data.status === "paid" ? (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" />
            <h1 className="font-heading text-2xl font-semibold mt-4" data-testid="order-paid-title">Payment received</h1>
            <p className="text-sm text-muted-foreground mt-2">Thank you, {data.nursery_name}. Invoice ORD-{data.number} for {data.course_title} (£{data.total.toFixed(2)}) is now paid.</p>
            <a href={`${backend}/api/orders/invoice/${token}`} target="_blank" rel="noopener noreferrer"><Button variant="outline" className="mt-6" data-testid="order-paid-invoice-button">Download paid invoice</Button></a>
          </>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-semibold" data-testid="order-unpaid-title">{cancelled ? "Payment cancelled" : sid ? "Confirming payment..." : "Invoice due"}</h1>
            <p className="text-sm text-muted-foreground mt-2">Invoice ORD-{data.number} · {data.course_title} · £{data.total.toFixed(2)}</p>
            <a href={`${backend}/api/orders/pay/${token}`}><Button className="mt-6" data-testid="order-pay-button">Pay by card</Button></a>
          </>
        )}
      </Card>
    </div>
  );
}
